module.exports = __webpack_public_path__ + "static/media/9.4d07d8ed.jpg";